import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const getOrderRatingData = async (id: string) => {
  const response = await queryExecute({
    variables: {
      id,
    },
    query: graphql(`
      query GetOrderRatingData($id: String!) {
        getOrderRatingData(id: $id) {
          title
          target {
            targetId
            targetType
          }
          rating {
            type
            title
            maxNumStars
            tagsList {
              title
              iconName
              starRating
              tagsTitle
              tagList {
                tagId
                tagName
              }
            }
          }
        }
      }
    `),
  });

  return response.data.getOrderRatingData;
};
